import {priority} from '@priority-software/priority-proto-api/lib';
import {PriorityIcon} from '@priority-software/priority-style-react';
import {fieldValue} from '../../../stores/Form/Field';

export function chooseImageByZoomType(
    zoomType: priority.netitems.form.ZoomType,
    isReadonly?: boolean
) {
    const {ZoomType} = priority.netitems.form;
    switch (zoomType) {
        case ZoomType.SelectZoom:
            if (isReadonly) return PriorityIcon.searchThin;

            return PriorityIcon.zoom;
        case ZoomType.ZoomZoom:
            return PriorityIcon.searchThin;
        case ZoomType.EMailZoom:
            return PriorityIcon.msg;
        case ZoomType.AttachZoom:
            return PriorityIcon.attachment;
        case ZoomType.Date14Zoom:
        case ZoomType.Date8Zoom:
        case ZoomType.Date10Zoom:
            return PriorityIcon.calendar;
        case ZoomType.URLZoom:
            return PriorityIcon.globe;
        case ZoomType.HiddenZoom:
        case ZoomType.LinkFileZoom:
        case ZoomType.QEditZoom:
        case ZoomType.SpecialAttachZoom:
        default:
            return null;
    }
}

export function fieldValueToUrl(value: fieldValue) {
    const proptocol = 'http://';
    const secureProtocol = `https://`;
    const strValue = value.toString();
    return strValue.startsWith(secureProtocol) || strValue.startsWith(proptocol)
        ? strValue
        : secureProtocol + strValue;
}

export function fieldValueToEmail(value: fieldValue) {
    return `mailto:${value.toString()}`;
}
